require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-automechanika-at-the-birmingham-nec.json") })
        }
      }, "path---authors-automechanika-at-the-birmingham-nec");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-automechanika-at-the-birmingham-nec!./.cache/json/authors-automechanika-at-the-birmingham-nec.json
// module id = 1256
// module chunks = 231608221292675